import type { CSSProperties } from 'react';
import { colors } from './tokens';

type Props = {
  name: string;
  size?: number;
  src?: string;
  style?: CSSProperties;
};

export function Avatar({ name, size = 28, src, style }: Props) {
  const initials = name
    .split(' ')
    .map((s) => s[0]?.toUpperCase())
    .filter(Boolean)
    .slice(0, 2)
    .join('');
  const common: CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.surface,
    fontWeight: 600,
    letterSpacing: '-0.02em',
    fontSize: Math.max(10, Math.round(size * 0.45)),
    flexShrink: 0,
    overflow: 'hidden',
    ...style,
  };
  if (src) {
    return (
      <span style={common}>
        <img
          src={src}
          alt={name}
          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
        />
      </span>
    );
  }
  return (
    <span
      style={{
        ...common,
        background: `linear-gradient(135deg, ${colors.accent}, ${colors.warn})`,
      }}
    >
      {initials}
    </span>
  );
}
